export default {
    async airportList(params) {
		let actiontype = 'GetAirportInfosByGroup'
		return await this.fetch(actiontype, params);
	},
}


// WEBPACK FOOTER //
// ./src/interfaces/modules/city.js